import { Route, Routes } from 'react-router';
import styled from 'styled-components';
import { useHiddenMenu } from '../../../../contexts/HiddenMenuContext';
import { WidgetContextProvider } from '../../../../contexts/WidgetContext';
import routes from '../../../../routes';
import Chat from './Chat';
import HelpPanel from './HelpPanel';
import type { HelpContent } from './HelpPanel/helpPanelContent';
import OnboardingWidget from './OnboardingWidget';

const Wrapper = styled.div`
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 8px;
  bottom: 1.5rem;
  right: 1.5rem;
`;

const Widgets = ({
  hideChat,
  helpPanelcontentKey,
}: {
  hideChat?: boolean;
  helpPanelcontentKey?: keyof HelpContent;
}) => {
  return (
    <WidgetContextProvider>
      <Wrapper>
        <OnboardingWidget />
        {helpPanelcontentKey && <HelpPanel contentKey={helpPanelcontentKey} />}
        <Chat hide={Boolean(hideChat || helpPanelcontentKey)} />
      </Wrapper>
    </WidgetContextProvider>
  );
};

const WidgetsWrapper = () => {
  const { menuHidden } = useHiddenMenu();
  if (menuHidden) return null;
  return (
    <Routes>
      <Route
        path={routes.publishPressreleases.pattern}
        element={<Widgets helpPanelcontentKey="PRESSRELEASES" />}
      />
      <Route path={routes.reports.pattern} element={<Widgets hideChat />} />
      <Route path="*" element={<Widgets />} />
    </Routes>
  );
};

export default WidgetsWrapper;
